module.exports = __webpack_public_path__ + "img/fileadd.b0c41738.svg";